import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params, RoutesRecognized } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import * as moment from 'moment';

import { GeoJsonService } from './services/geo-json.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.sass']
})
export class AppComponent {
    private variable: string = "kdd";
    private baseTemp: number = 32;
    private latlng: string;
    private unit: string = "F";
    private unitBtnText: string = "°F to °C";
    private period: number = 30;
    private showChart = false;
    private tempFullName: string;
    private activeTabIdx: number = 0;
    private latestDate: string;
    private baseUrl: string = 'http://cloud.agroclimate.org/tools/kddMonitoring/';

    private periods = [
        { name: '', value: 0 },
        { name: 'Last 2 days', value: 2 },
        { name: 'Last 3 days', value: 3 },
        { name: 'Last 7 days', value: 7 },
        { name: 'Last 15 days', value: 15 },
        { name: 'Last 30 days', value: 30 },
        { name: 'Last 45 days', value: 45 },
        { name: 'Last 60 days', value: 60 },
        { name: 'Last 90 days', value: 90 },
        { name: 'Last 120 days', value: 120 },
        { name: 'Last 150 days', value: 150 }
    ];
    private baseTemps = [
        { nameF: '82°F', nameC: '27°C', value: 27 },
        { nameF: '86°F', nameC: '30°C', value: 30 },
        { nameF: '90°F', nameC: '32°C', value: 32 },
        { nameF: '93°F', nameC: '33°C', value: 33 },
        { nameF: '97°F', nameC: '36°C', value: 36 }
    ];

    constructor(private router: Router, private service: GeoJsonService, private route: ActivatedRoute, private location: Location) {

        this.router.events.subscribe(val => {
            if (val instanceof RoutesRecognized) {
                this.period = val.state.root.firstChild.params.period || 30;
                this.baseTemp = +val.state.root.firstChild.params.base || 32;
                this.variable = val.state.root.firstChild.params.var || "kdd";
                this.unit = val.state.root.firstChild.params.unit || "F";
                this.tempFullName = this.getFullTempName(this.unit, this.baseTemp);
            }
            if (this.router.url.indexOf('hist-dev') > -1) {
                this.activeTabIdx = 1;
            } else if(this.router.url.indexOf('map') > -1) {
                this.activeTabIdx = 0;
            }
        });

        this.route.params.subscribe((params) => {

            this.period = params["period"] || 30;
            this.baseTemp = params["base"] || 32;
            this.variable = params["var"] || "kdd";
            this.unit = params["unit"] || "F";

            this.tempFullName = this.getFullTempName(this.unit, this.baseTemp);
            //this.router.navigate(['/map/p', this.period, 'b', this.baseTemp, 'var', this.variable, 'u', this.unit]);
            this.service.getLatestDate(this.variable)
                .subscribe(res => {
                    this.latestDate = res.date;
                    this.periods[0].name = this.latestDate;
                });
        });
    }

    onSelectPeriod(period: number): void {
        this.period = period;
        this.navigateTo();
    }

    onSelectTemp(temp: number): void {
        this.baseTemp = temp;
        this.tempFullName = this.getFullTempName(this.unit, this.baseTemp);
        this.navigateTo();
    }

    onChangeUnit(): void {
        let temp: string = "";
        temp += " to " + this.unit;
        this.unit = this.unit == "F" ? "C" : "°F";
        this.unitBtnText = "°" + this.unit + temp;
        this.tempFullName = this.getFullTempName(this.unit, this.baseTemp);
        this.navigateTo();
    }

    getFullTempName(unit: String, value: number): string {
        for (let base of this.baseTemps) {
            if (base.value == value) {
                return unit == "F" ? base.nameF : base.nameC;
            }
        }
        return null;
    }

    ngOnInit() {
        if(window.location.href == this.baseUrl) {
            this.router.navigate(['/map/p', this.period, 'b', this.baseTemp, 'var', this.variable, 'u', this.unit]);
        }
    }

    navigateTo() {
        this.router.navigate([this.activeTabIdx == 0 ? '/map' : 'hist-dev', 'p', this.period, 'b', this.baseTemp, 'var', this.variable, 'u', this.unit]);
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts